import { api } from '.';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const inserirImagem = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await api.post('/imagemUsuario/inserir', params, { headers });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarImagem = async (id: number, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/imagemUsuario/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar imagem';
    throw new Error(errorMessage);
  }
};

export const obterImagem = async (id: number) => {
  try {
    const response = await api.get(`/imagemUsuario/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter imagem';
    throw new Error(errorMessage);
  }
};

export const inserirFotoPerfilNoCdn = async (params: FormData) => {
  try {
    const response = await api.post('/files/upload', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarFotoPerfilNoCdn = async (params: FormData) => {
  try {
    const response = await api.put('/files/update', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};